import * as React from 'react'
import { FC } from 'react'

import { AddNoteFormWrapper } from './AddNoteForm/AddNoteFormWrapper'
import { ENTITY_TYPES, LocationDTO } from '@sales-center/common'
import { ActionModal } from '@sales-center/components'

interface Props {
  entityId: number
  entityType: ENTITY_TYPES
  onClose: () => void
  onGoBack?: () => void
  open: boolean
  backToNotes?: boolean
  externalLocationId: string
  currentServiceLocation?: LocationDTO
}

export const AddNoteDrawer: FC<Props> = (props) => {
  const {
    entityId,
    entityType,
    onClose,
    open,
    externalLocationId,
    backToNotes,
    onGoBack,
    currentServiceLocation,
  } = props
  return (
    <ActionModal
      title={'Notes'}
      onClose={onClose}
      open={open}
      backIcon={backToNotes}
      onGoBack={onGoBack}
      customContinerWidth={{
        xs: '90vw',
        md: '50vw',
      }}
      disableBackdropClick
    >
      <AddNoteFormWrapper
        entityId={entityId}
        entityType={entityType}
        onClose={onClose}
        externalLocationId={externalLocationId}
        onGoBack={onGoBack}
        currentServiceLocation={currentServiceLocation}
      />
    </ActionModal>
  )
}

AddNoteDrawer.displayName = 'AddNoteDrawer'
